export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/company_clients/state.js